/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type RegionType = "CUSTOM" | "ITEM_LOCATION" | "LOCAL" | "NET_PRICE_REQUIREMENT" | "SHIPMENT_QUOTE_STATIC" | "TAX_NEXUS_V2" | "TRADE_FIRM_REGION" | "%future added value";
export type PdpSharedShippingInfo_shipmentQuote = {
    readonly handlingTimeDisplay: string | null;
    readonly totalAmount: {
        readonly currency: Currency | null;
        readonly amount: number | null;
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly buyerTotalAmount: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly buyerServiceMethodDisplay: string | null;
    readonly serviceMethod: {
        readonly serviceMethodType: string | null;
        readonly region: {
            readonly apiType: string | null;
            readonly code: string | null;
            readonly regionName: string | null;
            readonly regionType: RegionType | null;
        } | null;
    } | null;
    readonly showQuoteAsPending: boolean | null;
    readonly " $refType": "PdpSharedShippingInfo_shipmentQuote";
};
export type PdpSharedShippingInfo_shipmentQuote$data = PdpSharedShippingInfo_shipmentQuote;
export type PdpSharedShippingInfo_shipmentQuote$key = {
    readonly " $data"?: PdpSharedShippingInfo_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipmentQuote">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_shipmentQuote",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "displayShort",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "handlingTimeDisplay",
      "storageKey": "handlingTimeDisplay(displayShort:true)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "buyerTotalAmount",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerServiceMethodDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceMethodType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "apiType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showQuoteAsPending",
      "storageKey": null
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};
})();
(node as any).hash = '3c4c1b1ebe19dc2dfccb79bb26cd5c59';
export default node;
